import { IconButton, styled, Tab } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
const { PRIMARY_ICON } = COLORS;

export const EditProfileMediaTabItem = styled(Tab)(({ theme }) => ({
  fontSize: 10,
  [theme.breakpoints.up(450)]: {
    fontSize: 12,
  },
  [theme.breakpoints.up('sm')]: {
    fontSize: 14,
  },
}));

export const EditProfileMediaCheckBoxContainer = styled(IconButton)(({ theme }) => ({
  padding: 0,
  '&:hover': {
    background: 'transparent',
  },
  '& .MuiSvgIcon-root': {
    transform: 'scale(1.8)',
    fill: PRIMARY_ICON,
  },
}));
